export default "__VITE_ASSET__KpnzVF$M__"